'use client';

import { Spinner } from '@chakra-ui/react';

import { useJobGetQuery } from '@/modules/job/application';
import {
	JobApplicationForm,
	JobApplicationCompleted,
} from '@/modules/job/presentation/components';
import { useApplyJobHandler } from '@/modules/job/view-models';

type JobApplicationContainerProps = {
	jobId: string
};

export const JobApplicationContainer = ({ jobId }: JobApplicationContainerProps) => {
	const { data: job, isLoading } = useJobGetQuery(jobId);
	const { execute, isSuccess } = useApplyJobHandler();

	if (isLoading) return <Spinner />;

	// if (!job) notFound();

	if (!job) return <div>Job not found</div>;

	// TODO Handle Error
	// if (isError) {
	// }

	if (isSuccess) {
		return (
			<JobApplicationCompleted
				companyName=""
				jobTitle={job.title}
			/>
		);
	}

	return (
		<JobApplicationForm
			companyName=""
			handleApplyJob={() => execute(jobId)}
			jobTitle={job.title}
		/>
	);
};
